/**
 * Where a vendo's captive portal can be opened from the dashboard to LOOK at
 * it — `?preview=1` makes the portal fetch that vendo's real rates and theme,
 * fall back to sample content where something is missing, and show a
 * "presentation only" banner so nobody mistakes it for a live session.
 *
 * Prod host is portal.mysmartfi.ph (NOT portal.smartfi.ph — that hostname
 * does not resolve and was an old typo). Staging follows the dashboard's own
 * staging host; a deploy-time override wins over both.
 */
export const PORTAL_PREVIEW_HOST = import.meta.env.DEV
   ? // Follow the dashboard's own host so preview works from a phone on the
     // LAN too (localhost would point at the phone itself).
     `http://${window.location.hostname}:3002`
   : import.meta.env.VITE_PORTAL_BASE_URL ||
     (window.location.hostname === 'app-staging.smartfi.ph'
        ? 'https://portal-staging.mysmartfi.ph'
        : 'https://portal.mysmartfi.ph');

export const portalPreviewUrl = (portalSlug: string | null | undefined, theme?: string) => {
   const slug = portalSlug || 'demo';
   const themePart = theme ? `theme=${encodeURIComponent(theme)}&` : '';
   return `${PORTAL_PREVIEW_HOST}/${encodeURIComponent(slug)}?${themePart}preview=1`;
};

/** Opens the preview in a new tab, never over the dashboard. */
export const openPortalPreview = (portalSlug: string | null | undefined, theme?: string) => {
   window.open(portalPreviewUrl(portalSlug, theme), '_blank', 'noopener,noreferrer');
};

/** The REAL portal — exactly what a customer gets (locks, offline, real rates).
 *  This is what "Open portal" on the card and in the list open (Ray 2026-10-15:
 *  the sample-data preview hid the very things being checked). */
export const portalUrl = (portalSlug: string | null | undefined) =>
   `${PORTAL_PREVIEW_HOST}/${encodeURIComponent(portalSlug || 'demo')}`;

export const openPortal = (portalSlug: string | null | undefined) => {
   window.open(portalUrl(portalSlug), '_blank', 'noopener,noreferrer');
};
